import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getMediaServerInfo, getRoomOption } from '../../room';
import { DocumentStyled } from '../../share-layout/components/styles.web';
import { ROLE, checkRoleLevel, getLocalMemberRole } from '../members';
function CommonNoteLayout({ isMobile, mode, expand, isLeft, renderShareLeft, style, }) {
    const { t } = useTranslation();
    const isShowLvl = useSelector((state) => checkRoleLevel(getLocalMemberRole(state), ROLE.PRESENTER));
    const mediaInfo = useSelector((state) => getMediaServerInfo(state));
    const roomCode = useSelector((state) => getRoomOption(state)?.code);
    const groupId = ''; //useSelector(state => getGroupId(state) || "");
    // 공유 노트(Etherpad)는 shard 경로 없이 루트 /ep/p 에서 서빙된다.
    // jitsi WS는 /{shard}/xmpp-websocket 이라 shard 가 필요하지만, 노트 엔드포인트는 /ep/p 루트이므로
    // shard(예: /A)를 붙이면 404(Cannot GET /A/ep/p/...)가 난다. (dev 검증: /ep/p/{room}_ = 200 Etherpad)
    const serverPath = useMemo(() => '/ep/p', []);
    return (React.createElement(DocumentStyled, { "$name": APP.config.name, ...APP.config.ui.document, "$expand": expand },
        APP.config.option.hideParticipant && isShowLvl && isLeft && (React.createElement("div", { className: `share_list ${!expand && !isMobile && 'non_expand'}` },
            React.createElement("div", { className: "share_header" },
                React.createElement("p", null,
                    t(`share.${mode}`),
                    " ")))),
        renderShareLeft(),
        React.createElement("div", { style: { flex: '1', position: 'relative', background: '#f7f7f7' } },
            React.createElement("iframe", { src: `${window.location.origin}${serverPath}/${roomCode}_${groupId}`, style: style }))));
}
export default CommonNoteLayout;
